import React, { useState } from "react";
import { Modal, Pressable, TextInput, View, Platform } from "react-native";
import CCText from "@/Atoms/CCText";

const inputStyle = {
  borderWidth: 1,
  borderColor: "rgba(38,35,34,0.20)",
  borderRadius: 10,
  paddingHorizontal: 13,
  paddingVertical: 11,
  fontSize: 14,
  color: "#262322",
  backgroundColor: "#fff",
  ...(Platform.OS === "web" ? ({ outlineStyle: "none" } as any) : null),
};

const DURATIONS = [
  { label: "Weekend (2d)", days: 2 },
  { label: "1 week", days: 7 },
  { label: "2 weeks", days: 14 },
];

// Admin sheet to start a Puzzle Storm event.
export default function CreateEventSheet({
  visible,
  onCancel,
  onCreate,
  submitting,
}: {
  visible: boolean;
  onCancel: () => void;
  onCreate: (title: string, goal: number, startsAt: string, endsAt: string) => void;
  submitting?: boolean;
}) {
  const [title, setTitle] = useState("Puzzle Storm Weekend");
  const [goal, setGoal] = useState("5000");
  const [days, setDays] = useState(2);

  const goalNum = parseInt(goal, 10);
  const valid = title.trim().length > 0 && Number.isFinite(goalNum) && goalNum > 0;

  const submit = () => {
    if (!valid || submitting) return;
    const now = new Date();
    const end = new Date(now.getTime() + days * 86400000);
    onCreate(title.trim(), goalNum, now.toISOString(), end.toISOString());
  };

  return (
    <Modal transparent animationType="fade" visible={visible} onRequestClose={onCancel}>
      <View
        style={{
          flex: 1,
          backgroundColor: "rgba(38,35,34,0.45)",
          alignItems: "center",
          justifyContent: "center",
          padding: 24,
        }}
      >
        <View
          testID="create-event-sheet"
          style={{ backgroundColor: "#FAF6EB", borderRadius: 18, padding: 20, width: "100%", maxWidth: 420 }}
        >
          <CCText fontWeight="thunder" style={{ fontSize: 22, color: "#262322", marginBottom: 14 }}>
            Start a Puzzle Storm
          </CCText>

          <CCText style={{ fontSize: 12, fontWeight: "600", color: "#6B584D", marginBottom: 6 }}>Title</CCText>
          <TextInput testID="event-title-input" value={title} onChangeText={setTitle} style={inputStyle as any} />

          <CCText style={{ fontSize: 12, fontWeight: "600", color: "#6B584D", marginTop: 14, marginBottom: 6 }}>
            Goal (puzzles)
          </CCText>
          <TextInput
            testID="event-goal-input"
            value={goal}
            onChangeText={(v) => setGoal(v.replace(/[^0-9]/g, ""))}
            keyboardType="number-pad"
            style={inputStyle as any}
          />

          <CCText style={{ fontSize: 12, fontWeight: "600", color: "#6B584D", marginTop: 14, marginBottom: 8 }}>
            Duration
          </CCText>
          <View style={{ flexDirection: "row", gap: 8 }}>
            {DURATIONS.map((d) => {
              const active = days === d.days;
              return (
                <Pressable
                  key={d.days}
                  testID={`event-dur-${d.days}`}
                  onPress={() => setDays(d.days)}
                  style={{
                    paddingVertical: 8,
                    paddingHorizontal: 12,
                    borderRadius: 999,
                    backgroundColor: active ? "#3DAB9E" : "#fff",
                    borderWidth: active ? 0 : 1,
                    borderColor: "rgba(38,35,34,0.12)",
                  }}
                >
                  <CCText style={{ fontWeight: "600", color: active ? "#fff" : "#6B584D", fontSize: 12.5 }}>
                    {d.label}
                  </CCText>
                </Pressable>
              );
            })}
          </View>

          <View style={{ flexDirection: "row", gap: 10, marginTop: 18 }}>
            <Pressable
              testID="event-cancel-btn"
              onPress={onCancel}
              style={{ flex: 1, borderWidth: 1.5, borderColor: "#4D3F37", borderRadius: 10, paddingVertical: 12, alignItems: "center" }}
            >
              <CCText style={{ fontSize: 14, fontWeight: "600", color: "#4D3F37" }}>Cancel</CCText>
            </Pressable>
            <Pressable
              testID="event-create-btn"
              disabled={!valid || submitting}
              onPress={submit}
              style={{
                flex: 1,
                backgroundColor: valid && !submitting ? "#3DAB9E" : "#B7D9D3",
                borderRadius: 10,
                paddingVertical: 12,
                alignItems: "center",
              }}
            >
              <CCText style={{ fontSize: 14, fontWeight: "600", color: "#fff" }}>
                {submitting ? "Starting…" : "Start event"}
              </CCText>
            </Pressable>
          </View>
        </View>
      </View>
    </Modal>
  );
}
